import { ListTile, ListTileType, TileStatus } from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { VXLNode } from 'shared/renderer/types';

import quickActionListTile from './quickActionsListTile';

const listTile = (
  tile: ListTile,
  dependencies: HomeCardDependencies,
): VXLNode | null => {
  if (tile.status !== TileStatus.Loaded) {
    return null;
  }

  if (tile.listTileType === ListTileType.QuickActions) {
    return quickActionListTile(tile, dependencies);
  }

  return null;
};

export default listTile;
